import card from "./card";
import content from "./content";
import profile from "./profile";
import partner from "./partner";
import user from "./user";
import reporting from "./reporting";


export default {
	card,
	content,
	partner,
	profile,
	reporting,
	user
};